export default {
  ADDRESS_PAGE: 1,
  DELIVERY_OPTIONS_PAGE: 2,
  PAYMENT_PAGE: 3,
};
